import { anzahl as fAnzahl, euro, menge as fMenge } from '../format'
import type { Artikel } from '../api'

/**
 * Rangliste mit Balken in der Zeile.
 *
 * Der Balken steht neben der Zahl, nicht statt ihrer: er zeigt das
 * Verhaeltnis auf einen Blick, die Zahl bleibt ablesbar. Zugleich ist
 * das die Tabellenansicht, die eine Farbe unterhalb des Kontrastmasses
 * verlangt - hier steht ohnehin jeder Wert als Text.
 */
export function Rangliste({
  zeilen, nach = 'umsatz', leerText = 'Keine Artikel im Zeitraum.',
}: {
  zeilen: Artikel[]
  nach?: 'umsatz' | 'menge'
  leerText?: string
}) {
  if (!zeilen.length) return <div className="leer">{leerText}</div>
  const wert = (a: Artikel) => Math.abs(Number(nach === 'umsatz' ? a.umsatz : a.menge))
  const max = Math.max(...zeilen.map(wert), 1)
  const zeigeBons = zeilen.some((z) => z.auf_bons !== null && z.auf_bons !== undefined)

  return (
    <table>
      <thead>
        <tr>
          <th style={{ width: 28 }}></th>
          <th>Artikel</th>
          <th className="r" style={{ width: 78 }}>Menge</th>
          <th className="r" style={{ width: 104 }}>Umsatz</th>
          {zeigeBons && <th className="r" style={{ width: 74 }}>auf Bons</th>}
          <th style={{ width: 90 }}></th>
        </tr>
      </thead>
      <tbody>
        {zeilen.map((z, i) => (
          <tr key={z.artikel}>
            <td className="dezent zahl r">{i + 1}</td>
            <td>
              {z.artikel}
              {!!z.sofortstornos && (
                <span className="dezent" style={{ marginLeft: 7, fontSize: 11 }}>
                  {z.sofortstornos}× Sofortstorno
                </span>
              )}
            </td>
            <td className="r zahl">{fMenge(z.menge)}</td>
            <td className="r zahl">{euro(z.umsatz)}</td>
            {zeigeBons && (
              <td className="r zahl dezent">
                {z.auf_bons === null || z.auf_bons === undefined ? '–' : fAnzahl(z.auf_bons)}
              </td>
            )}
            <td>
              <div className="zeilenbalken-spur">
                <div className="zeilenbalken"
                     style={{ width: `${Math.max(2, (wert(z) / max) * 100)}%` }} />
              </div>
            </td>
          </tr>
        ))}
      </tbody>
    </table>
  )
}
